import { CardRow } from '../components/CardRow';
import { EmptyBlock, ErrorBlock, LoadingBlock, PageHeader } from '../components/states';
import { useSpeakers } from '../lib/queries';

export function SpeakersPage() {
  const speakers = useSpeakers();

  if (speakers.isPending) {
    return <LoadingBlock label="Loading the presenters…" />;
  }

  if (speakers.isError || !speakers.data) {
    return (
      <ErrorBlock
        message="The presenters could not be loaded."
        onRetry={() => void speakers.refetch()}
      />
    );
  }

  return (
    <>
      <PageHeader title="Speakers" subtitle={`${speakers.data.length} presenting this year`} />

      <main className="px-gutter py-5">
        {speakers.data.length === 0 ? (
          <EmptyBlock title="No presenters announced yet">
            They will appear here as the program is published.
          </EmptyBlock>
        ) : (
          <ul className="space-y-card">
            {speakers.data.map((speaker) => (
              <li key={speaker.id}>
                <CardRow
                  to={`/speakers/${speaker.id}`}
                  title={speaker.name}
                  subtitle={[speaker.titleRole, speaker.organization].filter(Boolean).join(' · ')}
                  personName={speaker.name}
                  photoAssetId={speaker.headshotAssetId}
                  meta={
                    speaker.sessions.length === 1
                      ? '1 session'
                      : `${speaker.sessions.length} sessions`
                  }
                />
              </li>
            ))}
          </ul>
        )}
      </main>
    </>
  );
}
